import emotionService from '@/services/ChatService/emotion';
import tagService from "@/services/ChatService/tag";

export default {emotionService, tagService};
